module.exports = __webpack_public_path__ + "static/img/中信建投.492efb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/中信建投.png
// module id = GPhe
// module chunks = 3